import { isNullOrUndefined } from "./validations";

/**
 * Extracts error field names from a structured error object.
 * This function processes an error object where each key corresponds to a field with an array of error objects.
 * It collects all unique error field names from these objects and returns them in an array.
 * @param {Object} errorData - An object containing error information where each key maps to an array of error objects.
 * @param {Object[]} errorData[]. - An array of error objects where each object may contain multiple key-value pairs.
 * @returns {string[]} An array of error field names extracted from the error objects.
 */
export const handleFieldsErrors = (errorData) => {
  const errorKeys = [];
  if (isNullOrUndefined(errorData) === false) {
    Object.keys(errorData).forEach((externalKey) => {
      const arrayOfErrors = errorData[externalKey];
      arrayOfErrors.forEach((error) => {
        for (const key in error) {
          if (Object.prototype.hasOwnProperty.call(error, key) === true) {
            errorKeys.push(key);
          }
        }
      });
    });
  }

  return errorKeys;
};
